"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useCallback, useEffect, useRef, useState } from "react";
interface LeaderboardHeaderControlMeasurements {
  readonly availableWidth: number;
  readonly viewModesWidth: number;
  readonly sortTabsWidth: number;
  readonly sortDropdownWidth: number;
  readonly curationTabsWidth: number;
  readonly curationDropdownWidth: number;
}
interface UseLeaderboardHeaderControlMeasurementsInput {
  readonly showCurationGroupSelect: boolean;
  readonly remeasureKey: string;
}
interface UseLeaderboardHeaderControlMeasurementsResult {
  readonly controlsRowRef: RefObject<HTMLDivElement | null>;
  readonly viewModeTabsRef: RefObject<HTMLDivElement | null>;
  readonly sortTabsProbeRef: RefObject<HTMLDivElement | null>;
  readonly sortDropdownProbeRef: RefObject<HTMLDivElement | null>;
  readonly curationTabsProbeRef: RefObject<HTMLDivElement | null>;
  readonly curationDropdownProbeRef: RefObject<HTMLDivElement | null>;
  readonly measurements: LeaderboardHeaderControlMeasurements;
}
const INITIAL_MEASUREMENTS: LeaderboardHeaderControlMeasurements = {
  availableWidth: 0,
  viewModesWidth: 0,
  sortTabsWidth: 0,
  sortDropdownWidth: 0,
  curationTabsWidth: 0,
  curationDropdownWidth: 0
};
const areMeasurementsEqual = (current: LeaderboardHeaderControlMeasurements, next: LeaderboardHeaderControlMeasurements): boolean => current.availableWidth === next.availableWidth && current.viewModesWidth === next.viewModesWidth && current.sortTabsWidth === next.sortTabsWidth && current.sortDropdownWidth === next.sortDropdownWidth && current.curationTabsWidth === next.curationTabsWidth && current.curationDropdownWidth === next.curationDropdownWidth;
export function useLeaderboardHeaderControlMeasurements(t0) {
  const $ = _c(11);
  const {
    showCurationGroupSelect,
    remeasureKey
  } = t0;
  const controlsRowRef = useRef(null);
  const viewModeTabsRef = useRef(null);
  const sortTabsProbeRef = useRef(null);
  const sortDropdownProbeRef = useRef(null);
  const curationTabsProbeRef = useRef(null);
  const curationDropdownProbeRef = useRef(null);
  const [measurements, setMeasurements] = useState(INITIAL_MEASUREMENTS);
  let t1;
  if ($[0] !== showCurationGroupSelect) {
    t1 = () => {
      const nextMeasurements = {
        availableWidth: controlsRowRef.current?.clientWidth ?? 0,
        viewModesWidth: viewModeTabsRef.current?.offsetWidth ?? 0,
        sortTabsWidth: sortTabsProbeRef.current?.offsetWidth ?? 0,
        sortDropdownWidth: sortDropdownProbeRef.current?.offsetWidth ?? 0,
        curationTabsWidth: showCurationGroupSelect ? curationTabsProbeRef.current?.offsetWidth ?? 0 : 0,
        curationDropdownWidth: showCurationGroupSelect ? curationDropdownProbeRef.current?.offsetWidth ?? 0 : 0
      };
      setMeasurements(currentMeasurements => areMeasurementsEqual(currentMeasurements, nextMeasurements) ? currentMeasurements : nextMeasurements);
    };
    $[0] = showCurationGroupSelect;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const measureNow = t1;
  let t2;
  if ($[2] !== measureNow || $[3] !== showCurationGroupSelect) {
    t2 = () => {
      let frameId = null;
      let timeoutId = null;
      let destroyed = false;
      const cancelScheduledMeasure = () => {
        if (frameId !== null && typeof globalThis.window.cancelAnimationFrame === "function") {
          globalThis.window.cancelAnimationFrame(frameId);
        }
        frameId = null;
        if (timeoutId !== null && typeof globalThis.clearTimeout === "function") {
          globalThis.clearTimeout(timeoutId);
        }
        timeoutId = null;
      };
      const scheduleMeasure = () => {
        cancelScheduledMeasure();
        if (typeof globalThis.window.requestAnimationFrame === "function") {
          frameId = globalThis.window.requestAnimationFrame(() => {
            frameId = null;
            if (!destroyed) {
              measureNow();
            }
          });
          return;
        }
        timeoutId = globalThis.setTimeout(() => {
          timeoutId = null;
          if (!destroyed) {
            measureNow();
          }
        }, 0);
      };
      scheduleMeasure();
      const observedElements = [controlsRowRef.current, viewModeTabsRef.current, sortTabsProbeRef.current, sortDropdownProbeRef.current, showCurationGroupSelect ? curationTabsProbeRef.current : null, showCurationGroupSelect ? curationDropdownProbeRef.current : null].filter(_temp);
      if (typeof ResizeObserver === "undefined") {
        globalThis.window.addEventListener("resize", scheduleMeasure);
        return () => {
          destroyed = true;
          cancelScheduledMeasure();
          globalThis.window.removeEventListener("resize", scheduleMeasure);
        };
      }
      const observer = new ResizeObserver(() => {
        scheduleMeasure();
      });
      observedElements.forEach(element_0 => observer.observe(element_0));
      return () => {
        destroyed = true;
        cancelScheduledMeasure();
        observer.disconnect();
      };
    };
    $[2] = measureNow;
    $[3] = showCurationGroupSelect;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== measureNow || $[6] !== remeasureKey || $[7] !== showCurationGroupSelect) {
    t3 = [measureNow, remeasureKey, showCurationGroupSelect];
    $[5] = measureNow;
    $[6] = remeasureKey;
    $[7] = showCurationGroupSelect;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== measurements) {
    t4 = {
      controlsRowRef,
      viewModeTabsRef,
      sortTabsProbeRef,
      sortDropdownProbeRef,
      curationTabsProbeRef,
      curationDropdownProbeRef,
      measurements
    };
    $[9] = measurements;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp(element) {
  return Boolean(element);
}